'use strict';

import keyMirror from 'keymirror';

const _pensionTypeSelectionValues = {
    PRE_RETIREMENT: 'preRetirement',
    RETIREMENT: 'retirement',
    MORE: 'more',
    PRE_RETIREMENT_NAME: 'Pre-retirement pension',
    RETIREMENT_NAME: 'Retirement benefit',
    MORE_NAME: '+ More'
};

const _pensionTypeBenefitValues = keyMirror({
    ENTRY_PRE_RETIREMENT: null,
    ENTRY_RETIREMENT: null,
    ENTRY_RETIREMENT_RETIRED_PRESERVE_AGE: null,
    ENTRY_RETIREMENT_RETIRED_PRE65: null,
    ENTRY_NON_PRESERVED_UNRESTRICTED: null,
    ENTRY_NON_PRESERVED_RESTRICTED: null,
    ENTRY_DISABILITY_TOTAL_PERMANENT: null,
    ENTRY_TERMINAL_ILLNESS: null,
    ENTRY_DEATH: null
});

const _disclaimers = keyMirror({
    COMMON_DISCLAIMER: null,
    OTHER_COMMON_DISCLAIMER: null,
    DEATH_BENEFIT_DISCLAIMER: null
});

const _minValidAge = 18;
const _retirementAge = 65;
const _preRetirementAge = 60;

module.exports = {
    RetirementAge: _retirementAge,
    PreRetirementAge: _preRetirementAge,
    MinimumValidAge: _minValidAge,
    PensionTypeData: {
        currentAge: '',
        dateOfBirth: '',
        selectedPensionType: '',
        selectedBenefitItem: '',
        showGeneralDisclaimer: false
    },
    ActionTypes: keyMirror({
        SELECT_PENSION_TYPE: null,
        SELECT_BENEFIT: null
    }),
    DisclaimerConstants: _disclaimers,
    PensionTypeSelection: [
        {
            id: _pensionTypeSelectionValues.PRE_RETIREMENT,
            name: _pensionTypeSelectionValues.PRE_RETIREMENT_NAME,
            isHidden: false,
            minAgeLimit: _minValidAge,
            maxAgeLimit: (_retirementAge - 1)
        },
        {
            id: _pensionTypeSelectionValues.RETIREMENT,
            name: _pensionTypeSelectionValues.RETIREMENT_NAME,
            isHidden: false,
            minAgeLimit: _minValidAge,
            maxAgeLimit: Number.MAX_VALUE
        },
        {
            id: _pensionTypeSelectionValues.MORE,
            name: _pensionTypeSelectionValues.MORE_NAME,
            isHidden: false,
            minAgeLimit: _minValidAge,
            maxAgeLimit: Number.MAX_VALUE
        }
    ],
    BenefitSelection: {
        'preRetirement': [
            {
                id: _pensionTypeBenefitValues.ENTRY_PRE_RETIREMENT,
                name: 'I am aged between my preservation age and age 64 but have not permanently retired - I note my preservation components will be applied to my pre-retirement pension(s) (unless you tell us otherwise) in the following order: unrestricted non-preserved; restricted non-preserved; preserved.',
                description: '',
                isHidden: false,
                minAgeLimit: _minValidAge,
                maxAgeLimit: (_retirementAge - 1)
            }
        ],
        'retirement': [
            {
                id: _pensionTypeBenefitValues.ENTRY_RETIREMENT,
                name: 'I am aged 65 or older.',
                description: '',
                isHidden: false,
                minAgeLimit: _retirementAge,
                maxAgeLimit: Number.MAX_VALUE
            },
            {
                id: _pensionTypeBenefitValues.ENTRY_RETIREMENT_RETIRED_PRESERVE_AGE,
                name: 'I am aged between my preservation age and age 64 and have permanently retired and do not intend to ever work again 10 hours or more per week.',
                description: '',
                isHidden: false,
                minAgeLimit: _minValidAge,
                maxAgeLimit: (_retirementAge - 1)
            },
            {
                id: _pensionTypeBenefitValues.ENTRY_RETIREMENT_RETIRED_PRE65,
                name: 'I am aged 60 to 64 and have ceased a gainful employment arrangement since turning age 60.',
                description: '',
                isHidden: false,
                minAgeLimit: _preRetirementAge,
                maxAgeLimit: (_retirementAge - 1)
            }
        ],
        'more': [
            {
                id: _pensionTypeBenefitValues.ENTRY_NON_PRESERVED_UNRESTRICTED,
                name: 'Non-preserved cash benefit',
                description: 'I am commencing a pension with my unrestricted non-preserved benefits.',
                isHidden: false,
                minAgeLimit: _minValidAge,
                maxAgeLimit: Number.MAX_VALUE
            },
            {
                id: _pensionTypeBenefitValues.ENTRY_NON_PRESERVED_RESTRICTED,
                name: 'Non-preserved cash benefit',
                description: 'I am commencing a pension with restricted non-preserved benefits only and have terminated my employment with an employer who has contributed to this fund.',
                isHidden: false,
                minAgeLimit: _minValidAge,
                maxAgeLimit: Number.MAX_VALUE
            },
            {
                id: _pensionTypeBenefitValues.ENTRY_DISABILITY_TOTAL_PERMANENT,
                name: 'Total and permanent disability benefit',
                description: 'I am permanently incapacitated.',
                isHidden: false,
                minAgeLimit: _minValidAge,
                maxAgeLimit: Number.MAX_VALUE
            },
            {
                id: _pensionTypeBenefitValues.ENTRY_TERMINAL_ILLNESS,
                name: 'Terminal illness benefit',
                description: 'I have a terminal medical condition.',
                isHidden: false,
                minAgeLimit: _minValidAge,
                maxAgeLimit: Number.MAX_VALUE
            },
            {
                id: _pensionTypeBenefitValues.ENTRY_DEATH,
                name: 'Death benefit',
                description: 'I am the beneficiary of a deceased member`s death benefit.',
                isHidden: false,
                minAgeLimit: _minValidAge,
                maxAgeLimit: Number.MAX_VALUE
            }
        ]
    },

    BenefitSelectionNames: {
        PRE_RETIREMENT: _pensionTypeBenefitValues.ENTRY_PRE_RETIREMENT,
        RETIREMENT_PRESERVE_AGE: _pensionTypeBenefitValues.ENTRY_RETIREMENT_RETIRED_PRESERVE_AGE,
        RETIREMENT: _pensionTypeBenefitValues.ENTRY_RETIREMENT
    },
    PensionTypeSelectionNames: {
        PRE_RETIREMENT: _pensionTypeSelectionValues.PRE_RETIREMENT,
        RETIREMENT: _pensionTypeSelectionValues.RETIREMENT,
        MORE: _pensionTypeSelectionValues.MORE
    },
    DisclaimerText: {
        RETIREMENT: _disclaimers.COMMON_DISCLAIMER,
        ENTRY_PRE_RETIREMENT: _disclaimers.COMMON_DISCLAIMER,
        ENTRY_RETIREMENT: _disclaimers.COMMON_DISCLAIMER,
        ENTRY_RETIREMENT_RETIRED_PRESERVE_AGE: _disclaimers.COMMON_DISCLAIMER,
        ENTRY_RETIREMENT_RETIRED_PRE65: _disclaimers.COMMON_DISCLAIMER,
        ENTRY_NON_PRESERVED_UNRESTRICTED: _disclaimers.COMMON_DISCLAIMER,
        ENTRY_NON_PRESERVED_RESTRICTED: _disclaimers.COMMON_DISCLAIMER,
        ENTRY_DISABILITY_TOTAL_PERMANENT: _disclaimers.OTHER_COMMON_DISCLAIMER,
        ENTRY_TERMINAL_ILLNESS: _disclaimers.OTHER_COMMON_DISCLAIMER,
        ENTRY_DEATH: _disclaimers.DEATH_BENEFIT_DISCLAIMER
    },
    PensionTypeBenefits: _pensionTypeBenefitValues
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/PensionTypeConstants.js